import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import Translations from "./Translations";
import DummyPasswordProtect from "./components/ui/DummyPasswordProtect";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <Translations>
      {/* TODO: remove this once the site is ready to be public */}
      {/* NOTE: anyone who knows how to inspect the html page will be able to crack the password */}
      <DummyPasswordProtect password="burritosinthepark">
        <App />
      </DummyPasswordProtect>
    </Translations>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
